<template>
    <query-by-major ref="changTab"></query-by-major>
</template>

<script>
    import QueryByMajor from "./queryByMajor";
    export default {
        name: "scoreSearch",
        components: {QueryByMajor},
        mounted() {
            this.$refs.changTab.changeTab('third');
        }
    }
</script>

<style scoped>

</style>